<template>
  <div class="wl-pop-hover-container">
    <div class="wl-pop-title-container">
      <span>{{data.row.title}}</span>
      <div v-if="showBtn" class="wl-pop-icon-container">
      </div>
    </div>

    <div class="wl-pop-main-container">
      <ul>
        <li>
          <span>{{$t('TABLE_HEADER_ENTITIES')}}</span>
          <span :title="entityName">
            {{entityName}}
          </span>
        </li>
        <li>
          <span>{{$t('FORM_LABEL_kpmgOwner')}}</span>
          <span>{{data.row.kpmgUserName}}</span>
        </li>
        <li>
          <span>{{$t('FORM_LABEL_clientOwner')}}</span>
          <span>{{data.row.clientUserName}}</span>
        </li>
        <li>
          <span>{{$t('FORM_LABEL_status')}}</span>
          <span>{{$t(getStatusLabel)}}</span>
        </li>
        <li>
          <span>{{$t('FORM_LABEL_priority')}}</span>
          <span>{{$t(getPriorityLabel)}}</span>
        </li>
      </ul>
    </div>

    <div class="wl-pop-bottom-container">
      {{$t('ACCOUNT_STATUS_CREATE_AT')}} {{data.row.createDateStamp| formatDate}}  {{$t('ACCOUNT_STATUS_SPREAD_BY')}} {{data.row.createBy}}
      {{$t('ACCOUNT_STATUS_UPDATE_BY')}} {{data.row.updateDateStamp| formatDate}} {{$t('ACCOUNT_STATUS_SPREAD_BY')}} {{data.row.updateBy}}
    </div>
  </div>
</template>
<script>
    import { dateFormat } from '@/utils';
    import {mapGetters} from 'vuex';

    export default {
        name: 'pop-up',
        filters: {
            formatDate: value => {
                if (value != null) {
                    return dateFormat(new Date(value));
                } else {
                    return value;
                }
            }
        },
        computed: {
            ...mapGetters('common', {
                getUser: 'getUser'
            }),
            getStatusLabel() {
                const value = this.data.row.matterStatus;
                let label = '';
                this.data.status.forEach(i => {
                    if (value == i.value) {
                        label = i.label;
                    }
                });
                return label;
            },
            getPriorityLabel() {
                const value = this.data.row.matterPriority;
                let label = '';
                this.data.priority.forEach(i => {
                    if (value == i.value) {
                        label = i.label;
                    }
                });
                return label;
            },
            entityName() {
                const value = this.data.row.entityList;
                return _.map(value, v => v.entityName).join(' / ');
            }
        },
        props: {
            data: {
                type: Object,
                default: {}
            },
            onEdit: {
                type: Function,
                default: () => {
                }
            },
            onDelete: {
                type: Function,
                default: () => {
                }
            },
            showBtn: {
                type: Boolean,
                default: true
            }
        }
    };
</script>
<style scoped>
  .wl-pop-hover-container {
    width: 280px;
    background: #fff;
    font-size: 12px;
  }

  .wl-pop-title-container,
  .wl-pop-main-container {
    border-bottom: 1PX solid #ccc;
  }

  .wl-pop-bottom-container,
  .wl-pop-title-container,
  .wl-pop-main-container {
    padding: 0 6px;
  }

  .wl-pop-title-container,
  .wl-pop-icon-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 28px;
  }

  .wl-pop-icon-container {
    height: 100%;
  }

  .wl-pop-bottom-container {
    font-size: 10px;
    line-height: 12px;
  }

  .wl-pop-main-container,
  .wl-pop-bottom-container {
    padding-top: 4px;
    padding-bottom: 4px;
  }

  .wl-pop-main-container ul li {
    height: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .wl-pop-main-container ul li:hover {
  }

  .wl-pop-main-container ul li span:nth-child(1) {
    flex: 0 0 110px;
  }

  .wl-pop-main-container ul li span:nth-child(2) {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .comment {
    display: block;
    width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
